import { faCircleDot } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function StatCard({number, text, className }) {
    return (
        <div className={className+' flex flex-col rounded-xl bg-gradient-to-b from-[#163F63] to-[#0E3458]'}>
            <div className='flex justify-between items-center text-white text-2xl px-4 pt-3'>
                <div>{number}</div>
                <FontAwesomeIcon icon={faCircleDot} size='1x' />
            </div>
            <div className='text-white text-xs px-4 pb-3'>
                {text}
            </div>
        </div>
    )
}
